const initialState = {
  wishlistProducts: [],
};

export const wishlistReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_LISTS_WISHLISTS":
      return {
        ...state,
        wishlistProducts: action.payload || [],
      };

    case "ADD_WISHLIST":
      const exists = state.wishlistProducts.find(p => p.id === action.payload.id);
      return {
        ...state,
        wishlistProducts: exists
          ? state.wishlistProducts
          : [...state.wishlistProducts, action.payload],
      };

    case "DELETE_WISHLIST":
      return {
        ...state,
        wishlistProducts: state.wishlistProducts.filter(p => p.id !== action.payload.id),
      };

    default:
      return state;
  }
};
